import { range } from 'lodash';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  height: 70px !important;
  width: 70px !important;
`;

const Branding = () => (
  <StyledContentLoader viewBox="0 0 70 70">
    <rect x="0" y="0" rx="8" ry="2" width="70" height="70" />
  </StyledContentLoader>
);

function BrandingLoader({ count = 12 }) {
  return range(count).map(item => <Branding key={item} />);
}

export default BrandingLoader;
